
import {defineComponent} from 'vue';
import ScreenWrapper from "@/components/elements/ScreenWrapper.vue";
import {useState} from "@/hooks/state";
import {ScreenTextsConfig} from "@/Screens.types";
import ActionButton from "@/components/elements/ActionButton.vue";

const state = useState();
export default defineComponent({
  components: {
    ActionButton,
    ScreenWrapper,
  },
  props: {
    msg: String,
    goTo: Function,
    config: Object as () => ScreenTextsConfig,
  },

  setup() {
    return {
      state
    }
  },
  data() {
    return {
      screen: this.config.screenId,
      imageMapId: Math.random().toString(36).substring(7),
    }
  },

  mounted() {
  },

  methods: {
    next() {
      this.goTo(this.config.screenNext)
    },

    openNextLink() {
      window.location.href = this.config.nextButtonLink;
    },

    onButtonClick(link: string) {
      if (link.startsWith('close')) {
        window.open('', '_self')
        window.close();
      } else {
        window.location.href = link;
      }
    }
  }
});
